import React, { useRef, useState } from "react";
import { CreatePanelController, DynamicDataObk } from "../../../Services";
import { useTranslation } from "react-i18next";
import { useLcIoOptions } from "../../../Containers/FullViewScreens/GlobalScreens/Settings/_Settings/useLcIoOptions";
import { ListStyle_Types, NewInputListHandles, NewSelectHandles } from "../../../Definitions";
import { MainContentPaddingTypes, NewButton, NewCreatableSelect, NewInputList, NewModal, NewSelect } from "../../BaseComponents";
import { current } from "@reduxjs/toolkit";

interface addLcModalProps {
  maintainControllerInfo?: (
    changed?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>,
    deleted?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>,
    created?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>
  ) => void;
  closeModal: () => void;
}

export default function AddLcModal({ closeModal, maintainControllerInfo }: addLcModalProps) {
  const { t } = useTranslation();
  const { systemOptions, lanControllerCpuOptions } = useLcIoOptions();
  const inputRef = useRef<NewInputListHandles>(null);
  const creatableSelectRef = useRef<NewSelectHandles>(null);
  const selectRef = useRef<NewSelectHandles>(null);
  const [message, setMessage] = useState<string | null>(null);

  const handleCreate = () => {
    const createdController: CreatePanelController = {};

    if (inputRef && inputRef.current && inputRef.current.refs.current) {
      if (!createdController.name) setMessage(`${t("devices.boardNameMissing", {defaultValue: "board name missing" })}`);
      createdController.name = inputRef.current.refs.current[0].value.toString();
    }

    if (creatableSelectRef && creatableSelectRef.current && !!creatableSelectRef.current.value?.id) {
      createdController.cpu_id = creatableSelectRef.current.value.label ?? undefined;
    }

    if (selectRef && selectRef.current) {
      createdController.system_id = selectRef.current.value.id ? +selectRef.current.value.id : undefined;
    }

    if (inputRef.current) {
      if (!createdController.name) {
        inputRef.current.refs.current[0].setError();
      } else {
        if (maintainControllerInfo) {
          maintainControllerInfo({ data: [createdController] });
          closeModal();
        }
      }
      setTimeout(() => {
        setMessage(null);
      }, 2000);
    }
  };

  return (
    <NewModal
      header={t("devices.newLcBoard", { defaultValue: "new lc board" })}
      predefinedButtons={{
        onClose: closeModal,
      }}
      overrides={{  mainContentPadding: MainContentPaddingTypes.secondary }}
      mainContent={
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
            <NewInputList
              ref={inputRef}
              headers={[t("devices.boardName", { defaultValue: "board name" })]}
              placeholders={[""]}
              isRequired={[true]}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px",
              }}
            />
            <NewCreatableSelect
              ref={creatableSelectRef}
              header={t("devices.cpuId", { defaultValue: "cpu id" })}
              options={lanControllerCpuOptions}
              isSearchable
              isClearable
              valueOverrides={{
                regex: true,
                maxValueLength: 8,
              }}
            />
            <NewSelect
              ref={selectRef}
              header={t("devices.system", { defaultValue: "system" })}
              options={systemOptions}
            />
          </div>
      }
      footerContent={<NewButton
        content={t("buttons.create", { defaultValue: "create" })}
        onClick={handleCreate}
      />}
      footerMessage={message ?? ""}
    />
  );
}
